import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CreatePaste from "@/pages/CreatePaste";
import PasteShare from "@/pages/PasteShare";
import ViewPaste from "@/pages/ViewPaste";

function App() {
  return (
    <div className="App min-h-screen flex flex-col bg-background text-foreground">
      <BrowserRouter>
        <Header />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<CreatePaste />} />
            <Route path="/p/:id" element={<ViewPaste />} />
            <Route path="/p/:id/share" element={<PasteShare />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          className: "!font-mono !text-xs !rounded-none !border !border-foreground/20",
        }}
      />
    </div>
  );
}

export default App;
